__turbopack_context__.v({
  "categoryTags": "EventsTodaySlider-module-scss-module__E0tjoW__categoryTags",
  "contentSlideCopy": "EventsTodaySlider-module-scss-module__E0tjoW__contentSlideCopy",
  "contentSlideGrid": "EventsTodaySlider-module-scss-module__E0tjoW__contentSlideGrid",
  "contentSlideImage": "EventsTodaySlider-module-scss-module__E0tjoW__contentSlideImage",
  "contentSlideImageCol": "EventsTodaySlider-module-scss-module__E0tjoW__contentSlideImageCol",
  "contentSlideInfo": "EventsTodaySlider-module-scss-module__E0tjoW__contentSlideInfo",
  "contentSlideTitle": "EventsTodaySlider-module-scss-module__E0tjoW__contentSlideTitle",
  "contentSwiperSlide": "EventsTodaySlider-module-scss-module__E0tjoW__contentSwiperSlide",
  "eventFactsSpacing": "EventsTodaySlider-module-scss-module__E0tjoW__eventFactsSpacing",
  "favoriteButton": "EventsTodaySlider-module-scss-module__E0tjoW__favoriteButton",
  "header": "EventsTodaySlider-module-scss-module__E0tjoW__header",
  "headerCopy": "EventsTodaySlider-module-scss-module__E0tjoW__headerCopy",
  "headerTitle": "EventsTodaySlider-module-scss-module__E0tjoW__headerTitle",
  "headerTitleH1": "EventsTodaySlider-module-scss-module__E0tjoW__headerTitleH1",
  "inlineBlock": "EventsTodaySlider-module-scss-module__E0tjoW__inlineBlock",
  "paginationDots": "EventsTodaySlider-module-scss-module__E0tjoW__paginationDots",
  "paginationWrapper": "EventsTodaySlider-module-scss-module__E0tjoW__paginationWrapper",
  "slideGrid": "EventsTodaySlider-module-scss-module__E0tjoW__slideGrid",
  "slideImage": "EventsTodaySlider-module-scss-module__E0tjoW__slideImage",
  "slideImageCol": "EventsTodaySlider-module-scss-module__E0tjoW__slideImageCol",
  "slideImageWrapper": "EventsTodaySlider-module-scss-module__E0tjoW__slideImageWrapper",
  "slideInfoCol": "EventsTodaySlider-module-scss-module__E0tjoW__slideInfoCol",
  "slideTitle": "EventsTodaySlider-module-scss-module__E0tjoW__slideTitle",
  "swiperButtons": "EventsTodaySlider-module-scss-module__E0tjoW__swiperButtons",
  "swiperOverflowVisible": "EventsTodaySlider-module-scss-module__E0tjoW__swiperOverflowVisible",
  "swiperSlide": "EventsTodaySlider-module-scss-module__E0tjoW__swiperSlide",
});
